import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";

const ShareholderSummary = ({ shareholders, summaryLoaded }) => {
  const { t } = useTranslation();
  
  return (
    summaryLoaded &&
    shareholders.map((shareholder, index) => {
      return (
        <div key={shareholder.id + " " + index + "_key"}>
          <Grid container pt="1" sx={{ fontSize: "14px" }}>
            <Grid item xs={4}>
              <strong>{t("Partner.Name")}</strong>: <span>{shareholder.shareHolderPartnerName || ""}</span>
            </Grid>
            <Grid item xs={4}>
              <strong>{t("Partner.Percent")}</strong>:{" "}
              <span>{t("PERCENT_NUMBER", { number: shareholder.sharePercent })}%</span>
            </Grid>
          </Grid>
        </div>
      );
    })
  );
};

ShareholderSummary.propTypes = {
  shareholders: PropTypes.array,
  summaryLoaded: PropTypes.bool.isRequired
};

export default ShareholderSummary;
